import { useEffect, useRef } from "react";
import { MapPin } from "lucide-react";

export const RWANDA_CITIES = [
  "Kigali", "Musanze", "Huye", "Rubavu", "Muhanga", "Rwamagana",
  "Nyagatare", "Karongi", "Nyanza", "Kayonza", "Rusizi", "Ruhango",
  "Gicumbi", "Kibungo", "Byumba",
];

/** Dropdown of Rwandan city suggestions shown on focus of the "Where?" input. */
export default function LocationSuggestions({ query, open, onClose, onPick }) {
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open, onClose]);

  if (!open) return null;

  const q = query.trim().toLowerCase();
  const matches = q
    ? RWANDA_CITIES.filter((c) => c.toLowerCase().includes(q))
    : RWANDA_CITIES;

  return (
    <div
      ref={boxRef}
      className="absolute left-0 right-0 top-full z-50 mt-2 max-h-96 overflow-y-auto rounded-2xl bg-white p-2 text-left text-slate-900 shadow-2xl"
    >
      {!q && (
        <p className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wide text-slate-400">
          Popular cities
        </p>
      )}

      {matches.length > 0 ? (
        matches.map((city) => (
          <button
            key={city}
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onPick(city)}
            className="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm hover:bg-slate-100"
          >
            <MapPin className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span>{city}</span>
          </button>
        ))
      ) : (
        <p className="px-3 py-2 text-sm text-slate-400">No matches for "{query}"</p>
      )}
    </div>
  );
}
